import { Divider as FluentDivider } from "@fluentui/web-components";
/**
 * Divider
 * @summary A Divider Custom HTML Element that semantically separates content or serves for visual presentation.
 *
 * @example
 * ```html
 * <fabric-divider role="separator" orientation="vertical" align-content="center" appearance="strong" inset></fabric-divider>
 * ```
 *
 * @attr {DividerRole} role - The role of the element, either 'separator' or 'presentation'.
 * @attr {DividerOrientation} orientation - The orientation of the divider, either 'horizontal' or 'vertical'.
 * @attr {DividerAlignContent} alignContent - Align content within divider, options are 'center', 'start', 'end'.
 * @attr {DividerAppearance} appearance - Divider appearance, options are 'strong', 'brand', 'subtle'.
 * @attr {boolean} inset - Whether the divider should be inset.
 *
 * @prop {DividerRole} role - The role of the element, either 'separator' or 'presentation'.
 * @prop {DividerOrientation} orientation - The orientation of the divider, either 'horizontal' or 'vertical'.
 * @prop {DividerAlignContent} alignContent - Align content within divider, options are 'center', 'start', 'end'.
 * @prop {DividerAppearance} appearance - Divider appearance, options are 'strong', 'brand', 'subtle'.
 * @prop {boolean} inset - Whether the divider should be inset.
 *
 * @slot - The default slot for the divider content.
 *
 * @extends FluentDivider
 * @tagname fabric-divider
 * @public
 */
export class Divider extends FluentDivider {
}
//# sourceMappingURL=divider.js.map